import { mapActions } from 'vuex';

const progressBar_mixin = {       
    methods: {
        ...mapActions('progressBar_store', ['ACT_progressBar']),
        MIX_progressBar (payload) {
            ////console.log('payload = ' + JSON.stringify(payload, null, 2))
            this.ACT_progressBar(payload);
        }
    }
}

export default {
  install (Vue) {
    Vue.mixin(progressBar_mixin)
  }
};

 

  
  